import React from 'react';

const COLORS = ['#0F2040', '#4ABFCF', '#B45309', '#BE123C', '#047857', '#7C3AED', '#64748B', '#F59E0B'];
const W = 1200; const H = 210; const PL = 40; const PR = 16; const PT = 12; const PB = 30;

/** Stacked bars: override reasons used per month (distinct deals), so leadership sees patterns forming. */
export function ReasonTrendChart({ trend, onSelect, selected }) {
  const pts = trend?.points || []; const reasons = trend?.reasons || [];
  const max = Math.max(1, ...pts.map((p) => p.total || 0));
  if (!pts.some((p) => p.total)) return <p className="text-[11px] text-slate-400" data-testid="reason-trend-empty">No term-discount overrides saved in the last 12 months — the reason trend appears as reps start overriding.</p>;
  const bw = (W - PL - PR) / pts.length; const inner = bw * 0.55;
  const y = (v) => PT + ((max - v) * (H - PT - PB)) / max;
  const color = (r) => COLORS[reasons.indexOf(r) % COLORS.length];
  return (
    <div data-testid="reason-trend-chart">
      <p className="text-[11px] font-semibold text-[#0F2040] mb-1">Reason trend <span className="font-normal text-slate-500">· deals saved with a term-discount override, by month and reason{onSelect ? ' · click a segment to list the deals' : ''}</span></p>
      <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-auto" role="img" aria-label="Override reasons by month">
        {[...new Set([0, Math.ceil(max / 2), max])].map((v) => <g key={v}><line x1={PL} x2={W - PR} y1={y(v)} y2={y(v)} stroke="#E2E8F0" strokeWidth="0.8" /><text x={PL - 6} y={y(v) + 4} textAnchor="end" fontSize="11" fill="#64748B">{v}</text></g>)}
        {pts.map((p, i) => {
          const x = PL + i * bw + (bw - inner) / 2; let acc = 0;
          return (
            <g key={p.month} data-testid={`reason-trend-${p.month}`}>
              {reasons.map((r) => {
                const c = p.counts[r] || 0; if (!c) return null;
                const y0 = y(acc + c); const h = y(acc) - y0; acc += c;
                const isSel = selected && selected.month === p.month && selected.reason === r;
                return <rect key={r} x={x} y={y0} width={inner} height={h} fill={color(r)} rx="2" className={onSelect ? 'cursor-pointer hover:opacity-80' : ''} stroke={isSel ? '#F59E0B' : 'white'} strokeWidth={isSel ? 3 : 1}
                  onClick={() => onSelect?.(isSel ? null : { month: p.month, reason: r, count: c })} data-testid={`reason-trend-seg-${p.month}-${reasons.indexOf(r)}`}><title>{`${p.month} · ${r}: ${c} deal${c === 1 ? '' : 's'} — click to list`}</title></rect>;
              })}
              {p.total > 0 && <text x={x + inner / 2} y={y(p.total) - 4} textAnchor="middle" fontSize="10" fill="#0F2040" fontWeight="600">{p.total}</text>}
              <text x={x + inner / 2} y={H - 10} textAnchor="middle" fontSize="11" fill="#64748B">{p.month.slice(2).replace('-', '/')}</text>
            </g>
          );
        })}
      </svg>
      <div className="flex flex-wrap gap-x-3 gap-y-1 mt-1" data-testid="reason-trend-legend">
        {reasons.map((r) => <span key={r} className="inline-flex items-center gap-1 text-[10px] text-slate-600"><span className="inline-block w-2.5 h-2.5 rounded-sm" style={{ backgroundColor: color(r) }} />{r}</span>)}
      </div>
    </div>
  );
}
